export default __webpack_public_path__ + "3c28af711ac3a27e61eba84762185d1e.webp";